import { Brand, BrandType } from "entities/brands/types";
import { ArticleCategory } from "entities/manageArticles/types";
import { BrandTabs } from "entities/pages/types";
import { upperFirst } from "lodash";
import ModulesContainer from "modules/brands/pages/ModulesContainer";
import ArticleDetailsPageContainer from "modules/manageArticles/pages/ArticleDetailsPage";
import ArticleGroupPage from "modules/manageArticles/pages/ArticleGroupPage";
import {
  BRAND_SUB_PAGE_PATH,
  MANAGE_ARTICLE_DETAILS_PATH,
  MANAGE_ARTICLES_GROUP_PATH,
} from "./paths";
import { privateRoutes } from "./routing";
import { RouteElement } from "./types";

const articlesCategories = [ArticleCategory.LEGAL, ArticleCategory.HELP];
const brandsTabs = [BrandTabs.Pages, BrandTabs.Settings];

export const areRoutesEqual = (pathname: string, route: string): boolean => {
  const regexp = new RegExp(route.replace(/:[a-zA-Z]+/, "[a-zA-Z0-9]+"));
  return regexp.test(pathname);
};

export const getDynamicRoutesWithBrands = (
  brands: Brand[],
  freeToPlayMainPageId: string,
) => {
  return Object.entries(privateRoutes).map(([key, route]) => {
    if (key === "pages") {
      const brandsElements: RouteElement[] = brands.flatMap((brand) => {
        return brandsTabs.map((brandTab) => {
          return {
            pathname:
              brand.id === BrandType.FREE
                ? `${route.pathname
                    .replace(":id", brand.id.toString())
                    .replace(":tabId", brandTab.toString())
                    .replace(":tabDetailsId", freeToPlayMainPageId)}`
                : `${route.pathname.replace(":id", brand.id.toString()).replace(":tabId", brandTab.toString())}`,
            title: upperFirst(brand.name),
            isMaintenanceMode: brand.isBrandMaintenanceMode,
            nestedRoute: {
              pathname: BRAND_SUB_PAGE_PATH,
              Component: ModulesContainer,
            },
            isHiddenInNavBar: brandTab === BrandTabs.Settings,
          };
        });
      });

      return {
        ...route,
        elements: brandsElements,
      };
    }

    if (key === "manageArticles") {
      const articlesElements: RouteElement[] = brands.flatMap((brand) => {
        return articlesCategories.map((category) => {
          return {
            pathname: `${route.pathname.replace(":brandId", brand.id.toString()).replace(":categoryId", category.toString())}`,
            title: upperFirst(brand.name),
            nestedRoute: {
              pathname: MANAGE_ARTICLES_GROUP_PATH,
              Component: ArticleGroupPage,
              nestedRoutes: [
                {
                  pathname: MANAGE_ARTICLE_DETAILS_PATH,
                  Component: ArticleDetailsPageContainer,
                },
              ],
            },
            isHiddenInNavBar: category === ArticleCategory.HELP,
          };
        });
      });

      return {
        ...route,
        elements: articlesElements,
      };
    }

    return route;
  });
};
